'use client';

import type { ReactNode } from 'react';
import { usePathname } from 'next/navigation';

interface ConditionalMainProps {
  children: ReactNode;
}

const ConditionalMain = ({ children }: ConditionalMainProps) => {
  const pathname = usePathname();
  const isLivePath = pathname === '/live' || pathname.startsWith('/live/');

  return <main className={isLivePath ? 'flex-1' : 'flex-1 pb-10'}>{children}</main>;
};

export default ConditionalMain;
